import { RasaContext } from 'context'
import * as React from 'react'
import * as Constants from './constants'
import { VideoComponent } from './onboarding-videos'

type Props = any
interface State {
  video: Constants.DashboardVideo,
}

export class OnboardingVideo extends React.Component<Props, State> {
  public static contextType = RasaContext
  public constructor(p: Props) {
    super(p)
    this.state = {
      video: Constants.DASHBOARD_VIDEOS[1],
    }
  }

  public render = () =>
    <div className="onboarding-chart-small">
        <VideoComponent videoWidth={6} video={this.state.video}/>
    </div>
}
